import React from 'react';
import styled from 'styled-components';
import ProceduresContext, { ProceduresStore } from './ProceduresContext';
import ProceduresList from './ProceduresList';
import CategoriesDialog from '../functions/CategoriesDialog';
import EmptyStateMessage from '../common/EmptyStateMessage';
import ConfirmArchiveDialog from './ConfirmArchiveDialog.js';
import ReviseProcedureDialog from './ReviseProcedureDialog';
import CircularProgress from '@material-ui/core/CircularProgress';

const MultipleFunctionsContainer = styled.div`
    display:grid;
    grid-template-columns: 240px 1px 1fr;
`;

const OneFunctionContainer = styled.div`
    display:flex;    
`;

const ListContainer = styled.div`
   background-color:white;
   overflow-y:auto;
`;

const VerticalDivider = styled.div`
   background-color:gray;
`;

const DetailsContainer = styled.div`
    background-color:#f5f5f5;
    display:flex;
    align-items:center;
    width:100%;
    flex-direction:column;
    overflow-y:hidden;
`;

const FunctionDetailsContainer = styled.div`
   width:100%;
   overflow-y:auto;
`;

const CircularProgressContainer = styled.div`
   width:100%;
   align-items:center;
   justify-content:center;
   display:flex;
`;

const ProceduresMain = ({ isProjectSpecific, isProjectSpecificCorporate }) => {

    return (
        <ProceduresStore isProjectSpecific={isProjectSpecific} isProjectSpecificCorporate={isProjectSpecificCorporate}>
            <ProceduresContext.Consumer>
                {context => {
                    if (context.aboutCurrentUser) {
                        return <>
                            <CategoriesDialog />
                            <ReviseProcedureDialog />
                            <ConfirmArchiveDialog />
                            <ProceduresList />

                        </>
                    } else
                        return null;

                }}
            </ProceduresContext.Consumer>
        </ProceduresStore>
    )
}
export default ProceduresMain;